"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.adminReferralContract = void 0;
const core_1 = require("@ts-rest/core");
const zod_1 = require("zod");
const utils_1 = require("../utils");
const models_1 = require("./models");
const c = (0, core_1.initContract)();
exports.adminReferralContract = c.router({
    getRawInviteesForPlayer: {
        method: 'GET',
        path: '/player/:playerId/invitees',
        pathParams: zod_1.z.object({
            playerId: zod_1.z.string(),
        }),
        responses: {
            200: models_1.ZInvitedBySelect.extend({
                inviteeFirstName: zod_1.z.string(),
                inviteeLastName: zod_1.z.string(),
                referralId: zod_1.z.string(),
            }).array(),
            400: c.type(),
        },
    },
    getRawInvitersForPlayer: {
        method: 'GET',
        path: '/player/:playerId/inviters',
        pathParams: zod_1.z.object({
            playerId: zod_1.z.string(),
        }),
        responses: {
            200: models_1.ZInvitedBySelect.extend({
                inviterFirstName: zod_1.z.string(),
                inviterLastName: zod_1.z.string(),
                referralId: zod_1.z.string(),
            }).array(),
            400: c.type(),
        },
    },
    hasActiveReferralForPlayer: {
        method: 'GET',
        path: '/player/:playerId/referrals/active',
        pathParams: zod_1.z.object({
            playerId: zod_1.z.string(),
        }),
        responses: {
            200: zod_1.z.object({
                hasActiveReferral: zod_1.z.boolean(),
            }),
            400: c.type(),
        },
    },
    applyReferralCodeForPlayer: {
        method: 'POST',
        path: '/player/:playerId/referrals/apply',
        pathParams: zod_1.z.object({
            playerId: zod_1.z.string(),
        }),
        body: zod_1.z.object({
            referralCode: zod_1.z.string(),
        }),
        responses: {
            200: utils_1.successSchema,
            400: c.type(),
        },
    },
    getReferralStatsForPlayer: {
        method: 'GET',
        path: '/player/:playerId/referrals/stats',
        pathParams: zod_1.z.object({
            playerId: zod_1.z.string(),
        }),
        responses: {
            200: zod_1.z.object({
                count: zod_1.z.number(),
                maxReferrals: zod_1.z.number(),
                canReferMore: zod_1.z.boolean(),
            }),
            400: c.type(),
        },
    },
}, {
    pathPrefix: '/admin',
    commonResponses: {
        401: c.type(),
    },
});
//# sourceMappingURL=referral.admin.contract.js.map